import React from "react";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { useFetchData } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";

const ContactDetailsTable = ({ contactId }) => {
  if (!contactId) {
    return null;
  }

  return <LmsTable
    apiSuffix={`orgs/contact-usage-details/${contactId}`}
    isDisabled
    rowsBackgroundCustomColor={(rowData) => rowData?.count > 0 ? GlobalConstants.TABLE_ROW_COLORS.PINK : ""}
    sortByArray={["table", "column", "count"]}
  />;
};

const LmsOrganizationsMergeContacts = () => {
  const [{ fetchData }] = useFetchData();
  const myForm = new BCFormController({}, { submitSuffix: "orgs/comment" });
  myForm.addCenteredGroup([
    myForm.getDropdownField("Merge From", "orgs/list-contacts", { required: true, labelWarningText: "(This Contact will be deleted after merging)", dropdownSkipCache: true }),
    myForm.getDropdownField("Merge To", "orgs/list-contacts", { required: true, dropdownSkipCache: true })
  ], { blankWidth: 3 });

  myForm.addCenteredGroup([
    myForm.getInputField("Email:", {
      name: "mergeFromEmail",
      disabled: true,
      fontWeightLight: true,
      inline: true,
      noBackground: true,
      isHiddenFunc: (options) => !options?.inputs?.mergeFromId
    }),
    myForm.getInputField("Email:", {
      name: "mergeToEmail",
      disabled: true,
      fontWeightLight: true,
      inline: true,
      noBackground: true,
      isHiddenFunc: (options) => !options?.inputs?.mergeToId
    }),
  ], { blankWidth: 3 });

  myForm.addCenteredGroup([
    myForm.getComponent(({ inputs }) => {
      return <ContactDetailsTable contactId={inputs?.mergeFromId} />;
    }, { width: "5" }),
    myForm.getComponent(({ inputs }) => {
      return <ContactDetailsTable contactId={inputs?.mergeToId} />;
    }, { width: "5" })
  ], { blankWidth: 3 });

  const handleOnFormChanged = ({ inputs, setInputs }, lastUpdated) => {
    if (lastUpdated === "mergeFromId") {
      fetchData(`orgs/contact/${inputs?.mergeFromId}`).then(res => {
        if (res?.data?.email) {
          setInputs({ ...inputs, mergeFromEmail: res?.data?.email });
        }
      });
    }

    if (lastUpdated === "mergeToId") {
      fetchData(`orgs/contact/${inputs?.mergeToId}`).then(res => {
        if (res?.data?.email) {
          setInputs({ ...inputs, mergeToEmail: res?.data?.email });
        }
      });
    }
  };

  const handleSubmitValidation = async (inputs) => {
    if (inputs?.mergeFromId && inputs?.mergeToId && inputs?.mergeFromId === inputs?.mergeToId) {
      return { errorMessage: "The Merge From & To cannot be same." };
    }

    return { success: true };
  };

  const getSubmitSuffixFunc = ({ inputs }) => {
    return `orgs/merge-contacts?fromContactId=${inputs?.mergeFromId}&toContactId=${inputs?.mergeToId}`;
  };

  return (
    <LmsFormGenerator
      myForm={myForm}
      actions={[{ action: "save-new", text: "Merge", actionSubmitSuffix: getSubmitSuffixFunc }, "close"]}
      onFormChanged={handleOnFormChanged}
      handleSubmitValidation={handleSubmitValidation}
      submitConfirmationMessage="Are you sure you want to Merge these contacts?"
    />
  );
};

export default LmsOrganizationsMergeContacts;